import { ModalContent } from '@/components/Modal'

import { type EditTrafficProfileModalProps } from '../types'
import { Body } from './Body'
import { Header } from './Header'
import { useConfigureController } from '../hooks/useController'

export function Content(props: EditTrafficProfileModalProps) {
  const { trafficProfile } = props
  const { ready } = useConfigureController(trafficProfile)

  if (!ready) return null

  // footer has been removed from the `ModalContent` component
  // the footer will be rendered inside the `Body` component instead
  // this change is transparent from an end-user perspective
  return (
    <ModalContent header={<Header trafficProfile={trafficProfile} />}>
      <Body trafficProfile={trafficProfile} />
    </ModalContent>
  )
}
